import { ChangeDetectionStrategy, Component, inject, OnDestroy, OnInit } from '@angular/core';
import { BodyOverflowStyleStateStore } from '../../state/body-overlay.state';

@Component({
  selector: 'ticketing-modal',
  imports: [],
  templateUrl: './modal.component.html',
  styleUrl: './modal.component.css',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ModalComponent implements OnInit, OnDestroy {
  private readonly bodyOverflowState = inject(BodyOverflowStyleStateStore);

  ngOnInit(): void {
    this.bodyOverflowState.subscribe();
  }

  ngOnDestroy(): void {
    this.bodyOverflowState.unsubscribe();
  }
}
